// Third-Party Libraries
import moment from "moment"

// Types
import type { FormType } from "./validationSchema"

export const defaultValues: FormType = {
  memo: "",
  referensi: "",
  refund_return_detail: [],
  total_payment:0,
  trx_code:"",
  transaction_date: moment().format("YYYY-MM-DD")
}